<template>
	<page>
		<module>
			<view-list :work-type="workType" ref="view" selector :view-config="auth('b_aftersale_order_viewmanage')">
				<template #search>
					<m-search ref="search">
						<m-search-item label="工单编号">
							<c-input name="order_number"></c-input>
						</m-search-item>
<!--                        <m-search-item label="售后申请单号">-->
<!--                            <c-input name="aftersale_apply_no"></c-input>-->
<!--                        </m-search-item>-->
                        <m-search-item label="意见处理单">
                            <c-input name="complaint_no"></c-input>
                        </m-search-item>
						<m-search-item label="客户名称">
							<c-input name="customer_name"></c-input>
						</m-search-item>
						<m-search-item label="客户服务地址">
							<c-input name="customer_address"></c-input>
						</m-search-item>
						<m-search-item label="联系人">
							<c-input name="customer_contact"></c-input>
						</m-search-item>
						<m-search-item label="业务员">
							<c-input name="salesman_name"></c-input>
						</m-search-item>
                        <m-search-item label="售后网点">
                            <c-select name="after_sale_outlet_id" async @search="searchOutlet"></c-select>
						</m-search-item>
						<m-search-item label="负责人">
                            <c-select name="charge_user_ids" async :multiple="{limit:99,linefeed:true}" @search="searchUser"></c-select>
						</m-search-item>
						<m-search-item label="参与人">
                            <c-select name="member_user_ids" async :multiple="{limit:99,linefeed:true}" @search="searchUser"></c-select>
						</m-search-item>
						<m-search-item label="工单状态">
							<c-select name="status" :options="afterSaleOrderStateDic" multiple></c-select>
						</m-search-item>
						<m-search-item label="评价状态">
							<c-select name="evaluate_state" :options="evaluateStatusDic" multiple></c-select>
						</m-search-item>
						<m-search-item label="是否逾期">
                            <c-select name="is_delayed" :options="isDelayedDic"></c-select>
						</m-search-item>
						<m-search-item label="处理单确认状态">
							<c-select name="complaint_status" :options="complaintConfirmStatusDic"></c-select>
						</m-search-item>
						<m-search-item label="创建时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button color="main" v-if="auth('b_aftersale_order_edit')" prepend-icon="tf-add" @click="editOrder()">创建售后工单</c-button>
					<c-button v-if="auth('b_aftersale_order_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                </template>

				<template #batchOperate="{data}">
					<c-button v-if="auth('b_aftersale_order_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                    <c-button v-if="auth('b_aftersale_order_dispatch')" prepend-icon="tf-assign" @click="orderDispatch(data)">手工派单</c-button>
                    <c-button v-if="auth('b_aftersale_order_print')" prepend-icon="tf-print" @click="$refs.view.batchExportByTemplate()">批量打印</c-button>
                </template>

                <template #otherOperate>
                    <c-button v-if="auth('b_aftersale_order_log')" prepend-icon="tf-operate-record" @click="$refs.view.loadWorkLogDetail()">操作记录</c-button>
                </template>

				<template #order_number="{data}">
					<c-link @click="globalDialog('afterSaleOrderDetail', {props: {id: data.id}})">{{data.order_number}}</c-link>
				</template>

                <!--工单状态-->
                <template #status="{data}">
                    <c-state dict="afterSaleOrderStateDic" tag :value="data.status"></c-state>
                    <c-tooltip v-if="auth('b_aftersale_order_dispatch_log') && data.status == 1 && data.dispatch_id" tip="提示信息">
                        <c-link @click="globalDialog('afterSaleOrderDispatchLog', {props: {id: data.id}})" style="color: #ff4d4f; margin-left: 5px; cursor: pointer; font-weight: bold; font-size: 16px;">!</c-link>
                        <template #tip>
                            <p>自动派单失败，点击查看或在工单详情点击【派单日志】查看</p>
                        </template>
                    </c-tooltip>
                </template>
                <!--处理单状态-->
                <template #complaint_status="{data}">
                    <c-state dict="complaintConfirmStatusDic" tag :value="data.complaint_status"></c-state>
                </template>
                <!--紧急程度-->
                <template #urgency_level="{data}">
                    <c-state dict="urgencyLevelDic" tag :value="data.urgency_level"></c-state>
                </template>
                <!--出行方式-->
                <template #travel_mode="{data}">
                    <c-state dict="travelModeOptions" :value="data.travel_mode"></c-state>
                </template>
                <!--是否使用机台-->
                <template #use_machine="{data}">
                    <c-state dict="useMachineOptions" :value="data.use_machine"></c-state>
                </template>
                <!--预计服务时长-->
                <template #estimated_service_days="{data}">
                    {{data.estimated_service_days}} 天
                </template>

				<!--工单成本金额-->
				<template #product_money="{data}">
					￥{{data.estimated_cost_total}}
				</template>

                <!--工单进度%-->
                <template #order_complete_progress="{data}">
                    <span v-if="!data.product_count || data.product_count==0">-</span>
                    <c-progress v-else-if="data.status==5" :rate="[1, 1]" color="green"></c-progress>
                    <c-progress v-else-if="(data.status!=1 && data.status!=6)" :rate="[data.completion_progress || 0, 1]" :color="(data.completed_product_count/data.product_count>=1) ?'green':'blue'"></c-progress>
                    <span v-else>-</span>
                </template>
                <!--预估总成本-->
                <template #estimated_cost_total="{data}">
                    ￥{{data.estimated_cost_total}}
                </template>
                <!--评价状态-->
                <template #evaluate_state="{data}">
                    <c-state v-if="data.status == 5" dict="evaluateStatusDic"  :value="data.evaluate_state"></c-state>
                    <span v-else>-</span>
                </template>
                <!--服务类型-->
                <template #service_type="{data}">
                    <c-state dict="serviceTypeDic"  :value="data.service_type"></c-state>
                </template>
                <!--售后类型-->
                <template #aftersale_type="{data}">
                    <c-state dict="afterSaleTypeDic"  :value="data.aftersale_type"></c-state>
                </template>
                <!--评价状态-->
                <template #evaluate_state="{data}">
                    <c-state v-if="data.status == 5" dict="evaluateStatusDic"  :value="data.evaluate_state"></c-state>
                    <span v-else>-</span>
                </template>
                <!--工单逾期状态-->
                <template #is_delayed="{data}">
                    <c-state v-if="data.is_delayed == 1" tag color="red">
                        逾期<span v-if="data.delayed_days > 0">{{data.delayed_days}}天</span>
                    </c-state>
                    <span v-else>-</span>
                </template>
                <!--客户距离-->
                <template #customer_distance="{data}">
                    {{data.customer_distance}}公里
                </template>
                <!--驾车耗时-->
                <template #customer_duration="{data}">
                    {{data.customer_duration}}小时
                </template>
                <!--现场图-->
                <template #scene_images="{data}">
                    <c-file-list :value="data.scene_images" size="mini"></c-file-list>
                </template>
                <!--是否收费-->
                <template #is_fee="{data}">
                    <c-state dict="isChargeDic" :value="data.is_fee"></c-state>
                </template>
				<c-table-column
					type="button"
					label="操作"
					width="175"
					button-limit="3"
				>
					<template #default="{data}">
                        <c-table-button icon="tf-detail" @click="globalDialog('afterSaleOrderDetail', {props: {id: data.id}})">查看</c-table-button>
						<c-table-button v-if="auth('b_aftersale_order_edit')" :disabled="(data.process_start_date!=null||data.status == 3||data.status == 4||data.status == 5)"
                                        icon="tf-edit" @click="editOrder(data)">编辑</c-table-button>


                        <c-table-button :disabled="!(data.status == 6 && data.is_charge_user == 1)"
                                        icon="tf-output" @click="editAppointment(data)">确认预约时间</c-table-button>

                        <c-table-button v-if="auth('b_aftersale_order_member')" :disabled="!(data.status == 6 || data.status == 2 || data.status == 3)"
                                        icon="tf-auth" @click="addOrderMember(data)">团队成员</c-table-button>
                        <c-table-button v-if="auth('b_aftersale_order_dispatch') && (data.status == 1)"
                                        icon="tf-assign" @click="orderDispatch([data])">手工派单</c-table-button>
                        <c-table-button v-if="auth('b_aftersale_order_edit') && data.status == 3"
                                        icon="tf-address" @click="editLocation(data)">修改售后位置</c-table-button>
                        <c-table-button v-if="auth('b_aftersale_order_complaint_confirm') && data.status == 5 && data.complaint_status==1"
                                        icon="tf-check" @click="complaintConfirm(data)">处理单确认</c-table-button>
                        <c-table-button v-if="auth('b_aftersale_order_complaint_print') && data.complaint_no"
                                        icon="tf-print" @click="complaintPrint(data)">处理单打印</c-table-button>
                        <c-table-button v-if="auth('b_aftersale_order_complaint_print') && data.complaint_no"
                                        icon="tf-export" @click="complaintDownload(data)">处理单下载</c-table-button>
                        <c-table-button v-if="auth('b_aftersale_order_print') && !data.complaint_no" icon="tf-print" @click="$refs.view.exportByTemplate(data.id)">打印</c-table-button>
						<c-table-button v-if="auth('b_aftersale_order_edit') && (data.status == 0||data.status == 1)"
                                        icon="tf-trash" @click="removeOrder(data)">删除</c-table-button>
					</template>
				</c-table-column>
			</view-list>

            <!--修改预约时间-->
            <c-dialog ref="orderAppointmentDialog" title="确认预约时间" width="500" height="300" @resolve="orderAppointmentHandle">
                <c-form ref="orderAppointmentForm" vertical unit-width="100%">
                    <c-form-item label="客户预约时间" required>
                        <c-datetime name="appointment_start_time" type="date"
                                    :clear="false" format="yyyy-MM-dd"></c-datetime>
                    </c-form-item>
                    <c-form-item label="备注">
                        <c-input name="remark" type="textarea" maxlength="500" :rows="3"></c-input>
                    </c-form-item>
                </c-form>
            </c-dialog>
            <!--出行信息编辑-->
            <aftersale-order-travel-edit ref="travelEditDialog" @resolve="$refs.view.$refs.list.refresh()"></aftersale-order-travel-edit>
		</module>
	</page>
</template>

<script>
    import {mapState} from 'vuex'
    import aftersaleOrderTravelEdit from './aftersale_order_edit_travel.vue';

	export default {
        components: {
            aftersaleOrderTravelEdit
        },
		data() {
			return {
                workType: 2,
                view_id: 10002,
                order_id:0,
                appointment_time:[]            //服务起止时间
			}
		},

		computed: {
			// 获取dictName选项数据
			...mapState(['afterSaleOrderStateDic','urgencyLevelDic','evaluateStatusDic',
            'travelModeOptions','useMachineOptions','serviceTypeDic','afterSaleTypeDic','isDelayedDic','complaintConfirmStatusDic']),
		},
		
		methods: {
			/******新建/编辑售后工单*******/
			editOrder(data = {}) {
                this.globalDialog('aftersaleOrderEdit', {props: {id: data.id}}, this.$refs.view.$refs.list.update);
			},

            /******修改售后位置（服务中）*******/
            editLocation(data) {
                this.globalDialog('aftersaleOrderEditLocation', {data: data.id}, this.$refs.view.$refs.list.update);
            },

            /******添加售后工单成员*******/
            addOrderMember(data) {
                this.globalDialog('aftersaleOrderMember', {
                    data: {
                        id: data.id,
                        status: data.status,
                        schedule_start_time: data.schedule_start_time
                    }
                }, this.$refs.view.$refs.list.update);
            },
            /******编辑出行信息*******/
            editTravelInfo(data) {
                this.$refs.travelEditDialog.open(data.id);
            },
            /******修改工单预约时间*******/
            editAppointment(data) {
                this.order_id = data.id;
                this.$refs.orderAppointmentForm.set(data)
                this.$refs.orderAppointmentDialog.open();
            },

            //选择服务起止时间
            changeAppointmentTime(data){
                const start = new Date(data[0]);
                const end = new Date(data[1]);
                const difference = end - start; // 时间差，单位毫秒
                //取天数（向上取整）
                const days = Math.ceil(difference / 3600000 / 24) + 1;
                this.estimated_service_days = days;
            },

            //修改预约时间响应方法
            orderAppointmentHandle(stop, next) {
                stop();
                this.$refs.orderAppointmentForm.submit({
                    url: '/after/sale/order/edit/appointment_time',
                    dataFormatter: data => {
                        data.order_id = this.order_id
                        data.appointment_start_time = data.appointment_start_time;
                        return data;
                    },
                    rule: {
                        appointment_start_time: '请选择客户预约时间'
                    },
                    success: (data, res) => {
                        next();
                        this.$message({
                            message: '修改预约时间成功',  // 提示内容,
                            type: 'success'
                        });
                        this.$emit('resolve');
                    }
                });
            },
            /*******搜索网点*****************/
            searchOutlet(keyword, resolve){
                this.request({
                    url:'/system/options',
                    data: {
                        options_code:'AFTERSALE_OUTLET',
                        keyword:keyword
                    },
                    success:data => {
                        resolve(data);
                    }
                })
            },
            //手工派单
            orderDispatch(data){
                this.$bus.$on('aftersale_order_schedule.getIds', fun => {
                    fun(data.map(item => item.id));
                });
                this.navigateTo({
                    name: 'm_aftersale_order_schedule'
                })
            },

            /******删除售后工单************/
			removeOrder(data){
				this.$confirm({
					message:'确认删除售后工单【'+data.order_number+'】？删除后不可恢复',  // 提示内容,
					// buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/after/sale/order/remove',
							data: {id:data.id},
							loading: true,
							success: data => {
								this.$message({
									message:'删除成功',  // 提示内容,
									type: 'success'
								});
								//刷新
								this.$refs.view.$refs.list.refresh();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},

            /*******导入数据************/
            importData() {
                this.$refs.view.excelImport(Object.assign({}, {
                    view_id: this.view_id
                }));
            },
            //搜索售后工工程师
            searchUser(keyword, resolve) {
                this.request({
                    url:'/system/options',
                    data: {
                        options_code:'SYSUSER',
                        is_engineer: 1,
                        keyword:keyword
                    },
                    success:data => {
                        resolve(data);
                    }
                })
            },
            /******客诉处理单确认************/
            complaintConfirm(data){
                console.log(JSON.stringify(data));
                this.$confirm({
                    message:'是否确认意见处理单？工单号：'+data.order_number+'，处理单号：'+data.complaint_no,
                    cancelButton: true,
                    resolve: () => {
                        this.request({
                            url: '/after/sale/order/complaint_confirm',
                            data: {order_id:data.id},
                            loading: true,
                            success: data => {
                                this.$message({
                                    message:'确认成功',
                                    type: 'success'
                                });
                                this.$refs.view.$refs.list.refresh();
                            }
                        });
                    },
                    cancel: () => {},
                });
            },
            complaintPrint(data){
                this.request({
                    url: '/after/sale/order/complaint_print',
                    data: {order_id:data.id},
                    loading: true,
                    success: data => {
                        if(data.pdfData){
                            this.getApp().printBase64(data.pdfData);
                        }
                    }
                });
            },
            complaintDownload(data){
                let complaintNo = data.complaint_no;
                this.request({
                    url: '/after/sale/order/complaint_print',
                    data: {order_id:data.id},
                    loading: true,
                    success: res => {
                        if(res.pdfData){
                            let byteCharacters = atob(res.pdfData);
                            let byteNumbers = new Array(byteCharacters.length);
                            for(let i = 0; i < byteCharacters.length; i++){
                                byteNumbers[i] = byteCharacters.charCodeAt(i);
                            }
                            let byteArray = new Uint8Array(byteNumbers);
                            let blob = new Blob([byteArray], {type: 'application/pdf'});
                            let link = document.createElement('a');
                            link.href = URL.createObjectURL(blob);
                            link.download = '处理单_' + complaintNo + '.pdf';
                            link.click();
                            URL.revokeObjectURL(link.href);
                        }
                    }
                });
            },
		}
	}
</script>

<style lang="stylus" scoped>
</style>